import axios from 'axios';
import { extractDate, extractTime, getEntryStartTime, getEntryEndTime } from '../../utils/dateTimeUtils';
import { calculateEntryAmount } from '@/services/utils';
angular.module('leanlaw').controller('TimeEntriesCtrl', ['$scope', '$rootScope', '$q', '$window', '$filter', '$timeout', '$location', '$stateParams', '$state', 'userService', 'entriesManager', 'leanLawApi', 'codeService', 'matterManager', 'ModalService', 'clientManager', 'alerts', 'exportJson', 'embeddedTimeEntriesDashboardService', '$http', 'tracking', 'lists', function ($scope, $rootScope, $q, $window, $filter, $timeout, $location, $stateParams, $state, userService, entriesManager, leanLawApi, codeService, matterManager, ModalService, clientManager, alerts, exportJson, embeddedTimeEntriesDashboardService, $http, tracking, lists) {
  // Don't set the default sidebar state here
  // It must be set once the user has loaded (for default timekeeper)
  $scope.isSidebarExpanded = false;
  $scope.isDescriptionFocused = false; // Watched by description
  $scope.isSaving = false;
  $scope.shortDescriptions = false;
  $scope.printing = false;
  $scope.loading = true;
  $scope.pagination = {
    total: 0,
    limit: 50,
    offset: 0
  };
  $scope.summary = null;
  $scope.insights = false;
  $scope.sort = 'Date';
  $scope.reverse = false;
  $scope.codes = [];
  $scope.accounts = [];
  $scope.domain = leanLawApi.domain;
  let defaultHourValue;
  codeService.activityCodes().then(activity => {
    $scope.codes.activity = activity;
  });
  codeService.taskCodes().then(task => {
    $scope.codes.task = task;
  });
  userService.list().then(users => {
    $scope.accounts = users;
  });
  $scope.entry = entriesManager.newDefaultEntry({
    account: $scope.selectedAccount
  }, null, defaultHourValue);
  $scope.filteredEntries = [];
  // Copy of entry where changes are made
  $scope.editEntry = angular.copy($scope.entry);
  $scope.editEntry.client = $scope.editEntry.matter ? $scope.editEntry.matter.client : null;
  $scope.filter = {
    client: null,
    matter: null
  };
  $scope.search = '';
  $scope.areTimesVisible = false;
  $scope.selectedAccount;

  // Make sure window is always below the header, even after media queries are applied
  const resizeViewport = function resizeViewport() {
    const h = $('.ts.header').height();
    $('.timeentries, .edit-sidebar').css({
      top: `${h}px`
    });
  };

  // Watch for page resizes and adjust visible content accordingly
  angular.element($window).bind('resize', resizeViewport);
  // Default viewport top height:
  $('.timeentries, .edit-sidebar').css({
    top: '74px'
  });
  window.setInterval(resizeViewport, 1000);
  userService.me().then(me => {
    defaultHourValue = me.company.settings.timeEntryIncrement || 0.1;
    $scope.integration = me.company.integration;
    $scope.enableNewTimeEntry = me.settings?.enableNewTimeEntry ?? false;

    // Redirect to new time entry page based on user's preference (when feature flag allows it)
    if ($scope.enableNewTimeEntry && (me.features?.timeEntriesTab ?? false)) {
      $state.go('time');
    }
    $scope.account = me;
    $scope.me = me;
    $scope.insights = me.settings.insightsView;
    $scope.selectedAccount = {
      id: me.id
    };
    // Copied from entryFilter directive
    // This should prevent users from seeing entries that they shouldn't.
    if (me.role !== 'operator' && me.role !== 'accountant') {
      $scope.filter.account = me;
    }
    if (me.settings.selectedAccount) {
      $scope.selectedAccount = {
        id: me.settings.selectedAccount.id
      };
    }

    // // This will eventually set $scope.loading to false
    $scope.filterLoaded();
    if (me.settings.insightsView) {
      $scope.switchToDashboardView(true);
    } else {
      $scope.switchToDashboardView(false);
    }
  });

  // This allows us to link directly to the
  //  https://myleanlaw.co/#/timeentries?new
  if ($stateParams.new) {
    expandSidebar();
  }
  function closeSidebar() {
    // Unmark "new" or highlighted entries once this create session has closed
    $scope.entries = $scope.entries.map(e => {
      // Only unhilight new entries, otherwise edited entries would be unhilighted
      // Also, nothing should be highlighted after a create session
      if (e.isNewEntry || $scope.isNewEntry()) {
        delete e.highlighted;
        // Must be done to prevent the entry from being re-highlighted
        delete e.uiLastChange;
      }
      delete e.isNewEntry;
      return e;
    });
    $scope.isSidebarExpanded = false;
    $scope.entry = {};
    $scope.editEntry = {};
    $scope.filterEntries();
    $scope.$broadcast('clearClientMatter');
  }

  // Matter list is loaded when $scope.selectedAccount changes/is set
  // loadMatterList();

  // This is a wrapper around ModalService
  // Notice that the promise is returned and handled elsewhere
  const showConfirmDialog = details => {
    return ModalService.showModal({
      template: require('../modals/confirm/template.html'),
      inputs: {
        details
      },
      bodyClass: 'show-modal-overlay',
      controller: 'ConfirmModalController'
    });
  };

  // Determines if user is creating a new entry
  $scope.isNewEntry = function isNewEntry() {
    return $scope.isSidebarExpanded && !$scope.editEntry.id;
  };

  // Applies search filter to entries
  $scope.filterEntries = function (search) {
    $scope.filteredEntries = $scope.entries;
    addShortDescriptions();
  };
  $scope.immediateSearch = function () {
    debouncedSearch.cancel();
    loadEntries();
  };
  const debouncedSearch = _.debounce(() => {
    loadEntries();
  }, 1000);
  $scope.$watch('search', newValue => {
    if (newValue.length) {
      $scope.loading = true;
      debouncedSearch();
      return;
    }
    loadEntries();
  });
  $scope.matterCreated = function (matter) {
    $scope.isDescriptionFocused = true;
    loadMatterList().then(() => {
      $scope.editEntry.matter = matter;
    });
  };
  function adjustSummary(e, multiplier) {
    $scope.pagination.total += multiplier;
    const hours = multiplier * e.hours;
    const rateAmount = e.rate?.amount ?? 0;
    $scope.summary.totalHours += hours;
    const amount = calculateEntryAmount(rateAmount, hours);
    switch (e.billingType) {
      case 'billable':
        $scope.summary.billableHours += hours;
        $scope.summary.totalAmount += amount;
        break;
      case 'nonBillable':
        $scope.summary.nonBillableHours += hours;
        break;
      case 'fixedFee':
        $scope.summary.fixedFeeHours += hours;
        break;
      default:
        break;
    }
  }
  function loadMatterList() {
    // Load clients/matters used to determine if an entry has inaccessable c/m
    return userService.me().then(me => {
      const {
        autoAssign
      } = me.permissions.matters;
      const query = {
        scopeAccount: $scope.selectedAccount ? $scope.selectedAccount.id : null,
        scope: autoAssign ? 'all' : null
      };
      return matterManager.list(query).then(matters => {
        $scope.matters = _.sortBy(matters, m => m.label);
        return matterManager.listClientsFromMatters(matters).then(clients => {
          $scope.clients = _.sortBy(clients, c => c.label);
        });
      });
    });
  }

  // Saves the edit entry
  const saveEditEntry = function saveEditEntry() {
    const date = $scope.editEntry.date;
    const time = $scope.editEntry.startTime;

    // Set the startTime appropriately
    $scope.editEntry.startTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes());

    // NEW: Send localDateTime format for backend (Story #25310)
    // Backend will handle timezone conversion using user's timezone setting
    // TODO (Story #25310): Remove legacy startTime/endTime after migration complete
    $scope.editEntry.localDateTime = {
      date: extractDate(date),
      time: extractTime($scope.editEntry.startTime)
    };
    $scope.editEntry.matter.client = $scope.editEntry.client;
    if (!$scope.editEntry.rate) {
      // user cleared out rate field which implies standard rate
      $scope.editEntry.rate = {};
    }

    // Check to see if we're editing an existing entry
    if ($scope.editEntry.id && !$scope.editEntry.duplicate) {
      return leanLawApi.updateEntry({
        id: $scope.editEntry.id,
        body: $scope.editEntry
      }).then(entry => {
        entry.startTime = new Date(entry.startTime);
        entry.endTime = new Date(entry.endTime);
        entry.date = new Date(entry.startTime);
        entry.date.setHours(0);
        entry.date.setMinutes(0);
        const eidx = $scope.entries.findIndex(element => element.id === entry.id);

        // update existing entry in summary
        const oldEntry = $scope.entries.find(element => element.id === $scope.editEntry.id);

        // Remove oldentry from totals, and add new one
        adjustSummary(oldEntry, -1);
        adjustSummary(entry, +1);

        // Clear entry when the user is simply editing
        entry = entriesManager.newDefaultEntry(entry, null, defaultHourValue);

        // Mark the entry change time for highlighting
        entry.uiLastChange = new Date().getTime();
        entry.isNewEntry = false;
        entry.highlighted = true;
        entry.amount = entry.rate ? calculateEntryAmount(entry.rate.amount, entry.hours) : undefined;

        // Update entry locally
        $scope.entries[eidx] = entry;
        $scope.filterEntries();

        // Reset the entry field once the entry has been saved
        closeSidebar();
        return entry;
      }).catch(err => {
        $scope.error = err.body ? err.body.message : null;
        $scope.isSaving = false;
        if (err.body) {
          alerts.error(err);
        } else {
          alerts.error('Could not update entry');
        }
        return $q.reject(err);
      });
    }

    // Creating a new entry
    return entriesManager.create($scope.editEntry).then(entry => {
      // var entry = entriesManager.newDefaultEntry(entry);

      // Mark the entry change time for highlighting
      entry.uiLastChange = new Date().getTime();
      entry.isNewEntry = true;
      entry.highlighted = true;
      entry.amount = entry.rate ? calculateEntryAmount(entry.rate.amount, entry.hours) : undefined;

      // Add entry to list of entries
      if (typeof $scope.addEntry == 'function') $scope.addEntry(entry);
      return entry;
    }).catch(err => {
      alerts.error(err);
      $scope.error = err.body ? err.body.message : null;
      $scope.isSaving = false;
      return $q.reject(err);
    });
  };
  $scope.saveEntry = function saveEntry(isValid) {
    // isValid is passed as entryForm.$valid in ng-submit
    if (!isValid) return false;
    if ($scope.isSaving) return false;
    $scope.isSaving = true;
    const isNewEntry = $scope.editEntry.duplicate || !$scope.editEntry.hasOwnProperty('id') || !$scope.editEntry.id;
    $scope.editEntry.billedHours = $scope.editEntry.hours;
    saveEditEntry().then(newEntry => {
      $scope.isSaving = false;
      // Copy over persistent values when creating entries in bulk
      if (isNewEntry) {
        $scope.entry = entriesManager.newDefaultEntry({
          client: newEntry.matter.client,
          matter: newEntry.matter,
          account: newEntry.account,
          date: newEntry.date,
          codes: newEntry.codes,
          rate: newEntry.rate,
          billingType: newEntry.billingType,
          chargeId: newEntry.chargeId || null
        }, null, defaultHourValue);

        // Return focus to description field
        $scope.isDescriptionFocused = true;

        // Add summery once new entry is added.
        adjustSummary(newEntry, +1);
      }

      // Populate fields in the new entry sidebar
      $scope.entry.newEntryFromOld = true;
      $scope.editEntry = angular.copy($scope.entry);
      $scope.editEntry.client = $scope.editEntry.matter ? $scope.editEntry.matter.client : null;
    });
  };

  // This ensures that the user's progress isn't lost
  $scope.closeEntry = function closeEntry() {
    if ($scope.isSaving || $scope.isClosing) return;

    // Form of debounce; sometimes function is triggered twice by Angular's ng-click
    $scope.isClosing = true;
    let body = '';
    if (!$scope.editEntry.hasOwnProperty('id') && $scope.hasEntryChanged()) {
      // User is cancelling a new entry
      body = 'Are you sure you want to discard this new entry?';
    } else if ($scope.hasEntryChanged()) {
      // Cancelling changes to an existing entry
      body = "Are you sure you want to discard the changes you've made to this entry?";
    } else {
      // Nothing to lose
      $scope.isClosing = false;
      return closeSidebar();
    }

    // Cancelling changes to an existing entry
    showConfirmDialog({
      title: 'Discard Changes',
      body,
      confirmText: 'Discard Changes',
      rejectText: 'Keep editing',
      magenta: true
    }).then(modal => {
      // Close handler
      modal.close.then(result => {
        $scope.isClosing = false;
        // Result is true when user clicks confirm button
        if (result) closeSidebar();
      });
    });
  };
  $scope.expandSidebar = expandSidebar;
  function expandSidebar(entry, type, isFromCreateNewEntry) {
    if (!entry) {
      // Default account is the selected account
      let entryConfig = {
        account: $scope.selectedAccount
      };
      entryConfig = Object.assign(entryConfig, {
        client: $scope.filter.client,
        matter: $scope.filter.matter,
        account: $scope.filter.account
      });
      if ($scope.filter.period && $scope.filter.period.custom) {
        entryConfig = Object.assign(entryConfig, {
          date: new Date($scope.filter.period.range.startDate)
        });
      }
      entry = entriesManager.newDefaultEntry(entryConfig, null, defaultHourValue);
      entry.isFromCreateNewEntry = isFromCreateNewEntry;
    }

    // Check if we're opening an entry
    if ($scope.isSidebarExpanded && $scope.hasEntryChanged()) {
      if (entry) {
        // Selecting an entry
        confirmSwitchAction('selecting a different one');
      } else {
        // NOTE this is no longer an accessable path, but it can be
        // if we add a "New Entry" button to the edit entry sidebar

        // Creating a new entry
        confirmSwitchAction('creating a new one');
      }
    } else {
      // We're creating a new entry
      open();
    }

    // Actually open the sidebar
    function open() {
      // Allow description clearing for a new entry
      $scope.okToClearDescription = !entry || !entry.hasOwnProperty('id');

      // Copy the entry
      // Default account is selected account
      // Existing entry val overwrites default
      entry = Object.assign({
        account: $scope.selectedAccount
      }, entry);
      $scope.entry = entriesManager.newDefaultEntry(entry, null, defaultHourValue);
      $scope.editEntry = angular.copy($scope.entry);
      if (type === 'duplicate') {
        const startTime = new Date();
        const endTime = new Date();
        startTime.setHours(entry.startTime.getHours(), entry.startTime.getMinutes());
        endTime.setHours(entry.endTime.getHours(), entry.endTime.getMinutes());
        $scope.editEntry.date = startTime;
        $scope.editEntry.billed = false;
        $scope.editEntry.originalEntry = entry;
        $scope.editEntry.duplicate = true;
      }
      $scope.isSaving = false;
      $scope.isSidebarExpanded = true;
    }

    // Displays a modal with relevant text (actionString)
    // Used when the user might lose changes before saving
    function confirmSwitchAction(actionString) {
      // Check if user is editing an existing entry
      if ($scope.editEntry.hasOwnProperty('id')) {
        const canSaveEntry = $scope.isEntryValid;

        // Conditionally set modal content depending on whether the entry can be saved or not
        let message = `Would you like to finish editing the selected entry before ${actionString}?`;
        let confirmText = 'Finish Editing';
        let rejectText = 'Discard Changes';
        let ambiguousAnswer = true;
        if (canSaveEntry) {
          message = `Would you like to save your changes to the selected entry before ${actionString}?`;
          confirmText = 'Save and Continue';
          rejectText = 'Keep Editing';
          ambiguousAnswer = false;
        }
        showConfirmDialog({
          title: 'Unsaved Changes',
          body: message,
          confirmText,
          rejectText,
          ambiguousAnswer
        }).then(modal => {
          // Close handler
          modal.close.then(result => {
            // Result is true when user clicks confirm button
            if (result) {
              // Save the entry if possible, otherwise do nothing
              if (canSaveEntry) {
                $scope.isSaving = true;
                // Save and continue
                saveEditEntry().then(() => {
                  // Now create the new entry (blank)
                  open();
                });
              } else {
                // User wants to finish editing
                return;
              }
            } else {
              // Only reset the entry if the user doesn't want to continue editing
              if (!canSaveEntry) open();
            }
          });
        });
      } else {
        const canSaveEntry = $scope.isEntryValid;
        let message = `Do you want to save your new entry before ${actionString}?`;
        let confirmText = 'Save and Continue';
        let rejectText = 'Keep Editing';
        let ambiguousAnswer = false;
        if (!canSaveEntry) {
          message = `Would you like to keep editing your new entry before ${actionString}?`;
          confirmText = 'Keep Editing';
          rejectText = 'Discard Changes';
          ambiguousAnswer = true;
        }
        showConfirmDialog({
          title: 'Unsaved Changes',
          body: message,
          confirmText,
          rejectText,
          ambiguousAnswer
        }).then(modal => {
          // modal.element.modal();
          // Close handler
          modal.close.then(result => {
            if (result) {
              if (canSaveEntry) {
                $scope.isSaving = true;
                saveEditEntry().then(() => {
                  // Now create the new entry (blank)
                  open({});
                });
              } else {
                // User wants to keep editing
                return;
              }
            } else {
              if (!canSaveEntry) {
                // User wants to discard the changes
                open();
              } else {
                // User wants to keep editing
                return;
              }
            }
          });
        });
      }
    }
  }
  function makeReqFilter() {
    let reqFilter = angular.copy($scope.filter.period.range) || {};

    // Convert dates
    const keys = Object.keys(reqFilter);
    keys.forEach(key => {
      if (!reqFilter[key]) return;
      let date = new Date(reqFilter[key]);
      if (isNaN(date.getTime())) return;
      return reqFilter[key] = date;
    });
    if (reqFilter.endDate && reqFilter.endDate instanceof Date) {
      // NOTE Adding a day to the endDate because otherwise the last date won't be included
      // (the dates are includes with a time and timezone and so for example January 2017
      //  comes back from the filters as 2017-01-01T-07:00Z to 2017-01-31T-07:00Z but
      //  since this doesn't include any time on the 31st in a date-time comparison, we add
      //  a day to make it 2017-01-01T-07:00Z to 2017-02-01T-07:00Z)
      // ALSO make sure it cuts at midnight (when picking a custom range, the dates come through with time)
      reqFilter.endDate.setHours(0);
      reqFilter.endDate.setMinutes(0);
      reqFilter.endDate.setSeconds(0);
      reqFilter.endDate.setDate(reqFilter.endDate.getDate() + 1);
    }
    if (reqFilter.startDate && reqFilter.startDate instanceof Date) {
      reqFilter.startDate.setHours(0);
      reqFilter.startDate.setMinutes(0);
      reqFilter.startDate.setSeconds(0);
    }
    reqFilter.clientId = $scope.filter.client ? $scope.filter.client.id : null;
    reqFilter.matterId = $scope.filter.matter ? $scope.filter.matter.id : null;
    reqFilter.billedState = $scope.filter.billed ? $scope.filter.billed.id : null;
    reqFilter.customFlag = $scope.filter.customFlag ? $scope.filter.customFlag.id : null;
    reqFilter.activity = $scope.filter.codes && $scope.filter.codes.activity ? $scope.filter.codes.activity.id : null;
    reqFilter.task = $scope.filter.codes && $scope.filter.codes.task ? $scope.filter.codes.task.id : null;
    reqFilter.account = $scope.filter.account ? $scope.filter.account.id : null;
    reqFilter.chargeId = $scope.filter.charge ? $scope.filter.charge.id : null;
    if (!reqFilter.matterId) {
      reqFilter.chargeId = undefined;
    }
    if ($scope.search.trim() !== '') {
      reqFilter.search = $scope.search;
    }
    reqFilter.status = $scope.filter.archived.status;
    return reqFilter;
  }
  async function loadEntries(page = 1) {
    //This will load the updated user settings
    await userService.reload();
    if (!$scope.filter.loaded) return console.debug('Load cancelled because !filter.loaded');
    $scope.loading = true;
    $scope.entries = [];
    const reqFilter = makeReqFilter();
    const {
      limit
    } = $scope.pagination;
    reqFilter.limit = limit;
    reqFilter.offset = (page - 1) * limit;
    if ($scope.search.trim() !== '') {
      reqFilter.search = $scope.search;
    }
    if (reqFilter.startDate) {
      reqFilter.startDate = reqFilter.startDate.toNetworkDate();
    }
    if (reqFilter.endDate) {
      reqFilter.endDate = reqFilter.endDate.toNetworkDate();
    }
    entriesManager.list(reqFilter, 'time').then(entries => {
      if (!entries) return; // cancelled request
      const {
        list,
        pagination,
        summary
      } = entries;
      $scope.pagination.total = pagination.total;
      $scope.pagination.offset = pagination.offset;
      $scope.summary = summary || {};
      $scope.summary.billableHours = summary.billableHours || 0;
      $scope.summary.nonBillableHours = summary.nonBillableHours || 0;
      $scope.summary.fixedFeeHours = summary.fixedFeeHours || 0;
      $scope.summary.totalAmount = summary.totalAmount || 0;
      $scope.summary.totalHours = summary.billableHours + summary.nonBillableHours + summary.fixedFeeHours || 0;
      $scope.loading = false;
      $scope.entries = list.map(e => {
        // Add amount field to entries
        e.amount = e.rate ? calculateEntryAmount(e.rate.amount, e.hours) : undefined;
        return e;
      });
      $scope.filterEntries();
    }).catch(err => {
      bootbox.alert('Failed to load entries. Please refresh page to load', function (result) {
        $state.go('.', {}, {
          reload: true
        });
      });
    });
  }

  // Update the description with LEDES code if possible
  $scope.checkDescription = function (code, activity, task) {
    const codesSettings = $scope.me.company.settings.codes || {};
    let description = '';
    if (codesSettings.populateDescriptionsPlus) {
      // For populateDescriptionsPlus: always check both codes and combine them
      let activityDesc = $scope.editEntry.codes?.activity?.label || '';
      let taskDesc = $scope.editEntry.codes?.task?.label || '';
      if (activityDesc && taskDesc) {
        description = `${activityDesc}, ${taskDesc}`;
      } else if (activityDesc) {
        description = activityDesc;
      } else if (taskDesc) {
        description = taskDesc;
      }
    } else {
      // For populateDescriptions only: use the most recently selected code
      if (activity && $scope.editEntry.codes?.activity?.label) {
        description = $scope.editEntry.codes.activity.label;
      }
      if (task && $scope.editEntry.codes?.task?.label) {
        description = $scope.editEntry.codes.task.label;
      }
    }

    // Update the description if needed
    if (codesSettings.populateDescriptions && (!$scope.editEntry.description || $scope.okToClearDescription) && description) {
      $scope.editEntry.description = description;
    }
  };

  // Add an entry after it's created by entry-edit component
  $scope.addEntry = function (entry) {
    $scope.entries.push(entry);
    $scope.filterEntries();

    // Scroll entries window to top so user can see new entries
    $timeout(() => {
      $('.timeentries.ts').stop().animate({
        scrollTop: 0
      });
    }, 0);
  };

  // Story #41530: Get formatted start time using shared utility
  $scope.getFormattedStartTime = function (entry) {
    var useDateHandling = $scope.me && $scope.me.features && $scope.me.features.dateHandling;
    return getEntryStartTime(entry, useDateHandling);
  };

  // Story #41530: Get formatted end time using shared utility
  $scope.getFormattedEndTime = function (entry) {
    var useDateHandling = $scope.me && $scope.me.features && $scope.me.features.dateHandling;
    return getEntryEndTime(entry, useDateHandling);
  };
  $scope.selectEntry = function selectEntry(entry, type) {
    // Don't select the same entry again (this would reset the fields)
    if (type !== 'duplicate' && entry.id === $scope.editEntry.id) return false;

    // Don't switch entry when saving
    if ($scope.isSaving) return false;

    // Open sidebar with the selected entry if applicable
    // Sidebar will display modal if this might destroy changes
    $scope.expandSidebar(entry, type);
    $scope.editing = true;
  };

  // Delete the selected entry
  // This is only shown when an entry is selected
  $scope.deleteEntry = function deleteEntry() {
    if (!$scope.editEntry || !$scope.editEntry.id) return;
    showConfirmDialog({
      title: 'Delete Entry',
      body: 'Are you sure you want to delete the selected entry? This action cannot be undone.',
      confirmText: 'Yes, delete',
      rejectText: 'No, cancel',
      magenta: true
    }).then(modal => {
      // Close handler
      modal.close.then(result => {
        // Result is true when user clicks confirm button
        if (result) {
          leanLawApi.deleteEntry({
            id: $scope.editEntry.id
          }).then(() => {
            // Remove deleted entry
            $scope.entries = $scope.entries.filter(element => element.id !== $scope.editEntry.id);

            // Remove deleted entry from summery
            adjustSummary($scope.editEntry, -1);
            $scope.filterEntries();

            // We're done with this
            closeSidebar();
          });
        }
      });
    });
  };

  // Returns whether the selected/new entry has been modified by the user
  $scope.hasEntryChanged = function hasEntryChanged() {
    return $scope.entry && $scope.editEntry ? entriesManager.compareEntries($scope.entry, $scope.editEntry) : false;
  };
  $scope.export = function () {
    // Don't export when loading
    if ($scope.isSaving) return;
    if ($scope.loading) return;
    var {
      settings
    } = $scope.me.company;
    var customFlag = settings.labels && settings.labels.customFlag;
    // Name the file with the filter period
    var name = `leanlaw-export-${$scope.filter.period.label.split(' ').join('-').toLowerCase()}`;
    const reqFilter = makeReqFilter();
    if (reqFilter.startDate) {
      reqFilter.startDate = reqFilter.startDate.toNetworkDate();
    }
    if (reqFilter.endDate) {
      reqFilter.endDate = reqFilter.endDate.toNetworkDate();
    }
    entriesManager.list(reqFilter, 'time').then(entries => {
      if (!entries) return; // cancelled request
      const {
        list
      } = entries;
      var exports = list.map(e => {
        // Export the fields the user cares about
        // Story #41530: Use localDateTime.date when feature flag enabled
        var dateValue = $scope.me.features.dateHandling && e.localDateTime && e.localDateTime.date ? e.localDateTime.date : e.date;
        var item = {
          Date: $filter('dateLogical')(dateValue),
          Timekeeper: e.account.initials || e.account.name,
          'Client Id': e.matter.client.reference,
          Client: e.matter.client.name,
          'Matter Id': e.matter.reference ? e.matter.reference.indexOf('.') > -1 ? `="${e.matter.reference}"` : e.matter.reference : '',
          Matter: e.matter.name,
          Description: $scope.shortDescriptions ? e.shortDescription : e.description,
          Hours: e.hours,
          Notes: e.note
        };
        if ($scope.me.access.billing && $scope.me.permissions.time.viewRates) {
          item['Rate'] = e.rate.amount;
          item['Amount'] = calculateEntryAmount(e.rate.amount, e.hours);
        }
        item['BillingType'] = $filter("billingType")(e);
        if (customFlag) {
          item[customFlag] = e.customFlag ? 'Yes' : 'No';
        }
        if ($scope.areTimesVisible) {
          // Story #41530: Use unified helper functions for time display
          item['Start'] = $scope.getFormattedStartTime(e);
          item['End'] = $scope.getFormattedEndTime(e);
        }
        const matter = $scope.matters.find(m => m.id == e.matter.id);
        if (matter) {
          item['Responsible'] = matter.primary.initials || matter.primary.name;
        }
        item['Created'] = $filter('dateLogical')(new Date(e.created));
        return item;
      });
      var columnMap = {
        startTime: 'Date',
        'account.name': 'Timekeeper',
        'matter.client.label': 'Client',
        'matter.label': 'Matter',
        hours: 'Hours',
        rate: 'Rate',
        amount: 'Amount',
        start: 'Start',
        endTime: 'End',
        billable: 'Billable',
        billingType: 'BillingType'
      };
      if (!$scope.me.access.billing || !$scope.me.permissions.time.viewRates) {
        delete columnMap['rate'];
        delete columnMap['amount'];
      }
      var sortName = columnMap[$scope.sort];
      var sorted = $filter('orderBy')(exports, [sortName, 'Date'], $scope.reverse);
      exportJson.downloadCsv(sorted, name);
    });
  };
  $scope.exportQuickbooks = function () {
    // Don't export when loading
    if ($scope.isSaving) return;
    if ($scope.loading) return;
    var name = `leanlaw-quickbooks-${$scope.filter.period.label.split(' ').join('-').toLowerCase()}`;
    var exports = $scope.entries.map(e => {
      var item = {
        Date: $filter('dateLogical')(e.date),
        'Employee (EntityFullName)': e.account.name,
        'Customer (Client:Matter)': e.matter.client.label.replace(':', '') + ':' + e.matter.label.replace(':', ''),
        'Item (Product/Service)': 'Legal Services',
        'Class (?)': '',
        Billable: e.billingType === 'billable' ? 'Billable' : 'NotBillable',
        Description: $scope.shortDescriptions ? e.shortDescription : e.description,
        'Duration (Hours)': e.hours
      };
      return item;
    });
    exportJson.downloadCsv(exports, name);
  };
  $scope.print = function () {
    if ($scope.entries.length > 300) {
      showConfirmDialog({
        title: 'Warning',
        body: 'You have a very large number of time entries to print (a total of ' + $scope.entries.length + '). It will take some time to process so please be patient, or constrain your time entries by using the filters on the left.',
        confirmText: 'Print',
        rejectText: 'Cancel'
      }).then(modal => {
        // Close handler
        modal.close.then(result => {
          // Result is true when user clicks confirm button
          if (!result) return;
          unmarkNewEntries();
          print();
        });
      });
    } else {
      // New entries should be consolidated into existing entries
      unmarkNewEntries();
      print();
    }
  };
  function unmarkNewEntries() {
    $scope.entries = $scope.entries.map(e => {
      // Only unhilight new entries, otherwise edited entries would be unhilighted
      // Also, nothing should be highlighted after a create session
      if (e.isNewEntry) {
        delete e.highlighted;
      }
      delete e.isNewEntry;
      return e;
    });
  }
  function print() {
    $scope.printing = true;
    // HACK: Wait for render cycle
    $timeout(() => {
      $window.print();
      $scope.printing = false;
    }, 200);
  }
  $scope.$watch('filter', async (newValue, oldValue) => {
    if (!newValue.hasOwnProperty('period')) return;
    if ($scope.loading) return;
    $scope.loading = true;
    if (newValue.matter && newValue.matter?.clientId !== oldValue.matter?.clientId) {
      newValue.matter.client = await clientManager.get(newValue.matter.clientId);
    }
    loadEntries();
  }, true);
  $scope.filterLoaded = function () {
    // Without this the page will sometimes load without the $scope.account filter
    // $scope.account filters to a specific timekeeper and in some cases the
    // user doesn't have the rights to see other timekeepers time so it is critical
    // that we wait for the filter to load correctly or the user will see stuff
    // they are not supposed to see
    // This will be picked up by the watch function
    // $scope.loading = false;
    $scope.filter.loaded = true;
    loadEntries();
  };
  $scope.$watch('selectedAccount', loadMatterList);
  let loadedShortDescriptions = false;
  $scope.$watch('shortDescriptions', value => {
    if (value && !loadedShortDescriptions) {
      entriesManager.includeShortDescriptions().then(() => {
        loadedShortDescriptions = true;
        addShortDescriptions();
      });
    }
  });
  function addShortDescriptions() {
    if (loadedShortDescriptions) {
      $scope.filteredEntries.forEach(e => {
        e.shortDescription = entriesManager.shortDescription(e);
      });
    }
  }
  $scope.pageChanged = newPage => {
    loadEntries(newPage);
  };
  $scope.showAllEntries = () => {
    $scope.pagination.limit = $scope.pagination.total;
    loadEntries();
  };
  $scope.filterEntries();
  $scope.switchToDashboardView = async isInsight => {
    if (isInsight) {
      tracking.event('Insight', 'View');
    } else {
      tracking.event('Classic', 'View');
    }
    $scope.insights = isInsight;
    const path = `${$scope.domain}/accounts/${$scope.me.id}`;
    const payload = {
      settings: {
        insightsView: isInsight
      }
    };
    await $http.put(path, payload);
    embeddedTimeEntriesDashboardService.getEmbeddedTimeEntriesDashboard().then(async timeEntryDashboardId => {
      if (timeEntryDashboardId) {
        $window.localStorage.setItem('timeEntryDashboardId', timeEntryDashboardId);
        $scope.filter.timeEntryDashboardId = timeEntryDashboardId;
        $scope.filter.insights = isInsight;
        $window.localStorage.setItem('entriesFilter', JSON.stringify($scope.filter));
      }
    });
  };

  // Toggle new time entry UI
  $scope.toggleNewTimeEntryUi = async function () {
    try {
      // Get current state and toggle it
      const currentState = $scope.me.settings?.enableNewTimeEntry ?? false;
      const newState = !currentState;
      const path = `${$scope.domain}/accounts/${$scope.me.id}`;
      const payload = {
        settings: {
          enableNewTimeEntry: newState
        }
      };
      await axios.put(path, payload);
      tracking.event("Toggle", "SlideInTimeEntry", {
        enableNewTimeEntry: newState
      });
      await userService.reset();
      const me = await userService.me();
      const enableNewTimeEntry = me.features.timeEntriesTab && (me.settings?.enableNewTimeEntry ?? false);
      if (enableNewTimeEntry) {
        $state.go('time');
      }
    } catch (err) {
      alerts.error(err);
    }
  };
}]);